import { render, staticRenderFns } from "./PriceComparisonModal.vue?vue&type=template&id=3ddd4309"
import script from "./PriceComparisonModal.vue?vue&type=script&lang=js"
export * from "./PriceComparisonModal.vue?vue&type=script&lang=js"
import style0 from "./PriceComparisonModal.vue?vue&type=style&index=0&id=3ddd4309&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports